var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"back-head-box"},[_c('div'),_c('div',{staticClass:"right",on:{"click":_vm.setLange}},[_vm._v(_vm._s(_vm.$store.state.languageName))])])
}
var staticRenderFns = []

export { render, staticRenderFns }